// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class GlobalChangeOverTimeTable extends BasicReactTableWrapper {
  suffix(column) {
    if (column.Header !== "5-Year CAGR") { return; }

    return "%";
  }
}

GlobalChangeOverTimeTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default GlobalChangeOverTimeTable;
